/* 
 *  Copyright (c) Intel Corporation.  All Rights Reserved.
 *
 *  Primary entry point for transmitting data to endpoints
 */
/*--!!!!!ATTENTION!!!!!-----DO NOT DELETE code inside Webpack Macros,it will be used in Analytics SDK for Web */

// #IFDEF WebPack

import { globalEngine, ModuleManager } from "./Init";
import { logNormal , logInformation , logWarning , logError, logDebug, logConsole , logRawTrack , logTransports , logAutomationError} from "./bootstrap_web_ext";
import { getPluginFactory } from "./bootstrap_web_ext";
import { getSystemPlugin } from "./common";

// #ENDIF WebPack
    function RESTtransportPlugin()
    {
        this._plugin = null;     // holds the rest-ful plugin; we will get this during Initialize
        this._requestHeaders = {};     // holds the headers ()
        this._url = null;
        this.RESTClientAvailable = false;
    };
    RESTtransportPlugin.prototype = ModuleManager.create("transport_template");
    RESTtransportPlugin.prototype.constructor = RESTtransportPlugin;

    RESTtransportPlugin.prototype.GetVersion = function ()
    {
        try
        {
            if (!this._plugin)
            {
                return null;
            }
            return this._plugin.GetVersion();
        }
        catch (e)
        {
        }
    };

    RESTtransportPlugin.prototype._createRESTclientPlugin = function ()
    {
        try
        {
            this._plugin = getPluginFactory().Create("RESTclient");
            if (!this._plugin)
            {
                logError("RESTtransportPlugin:: Could not create RESTclient plugin");
                return false;
            }
            return true;
        }
        catch (e)
        {
            logError("RESTtransportPlugin:: Failed to initialize the plugin for '" + name + "': exception is '" + e.message + "'");
            return false;
        }
    };

    RESTtransportPlugin.prototype._setup = function () 
    {
        try
        {
            // now we figure out the connect parameters
            this._url = this._config["url"];
            if (!this._url) 
            {
                logError("Invalid (unspecified) URL for '" + this._name + "', version " + this.version);
                return false;
            }
            var verb = this._config["verb"];            // might be null
            if (!verb)
            {
                verb = "POST"; // talking to RESTfull interfaces should be POST by default
            }

            var username = this._config["username"];    // may be null
            var password = this._config["password"];    // may be null


            if (!this._createRESTclientPlugin())
            {
                logError('RESTtransportPlugin::_setup: Failed to create rest plugin');
                return false;
            }

            this._ConfigurePlugin(verb, username, password);
            this._plugin.Connect(this._url);
            // If we were unable to configure the plugin, we are not able to use it
            this.RESTClientAvailable = true;
            
            return true;
        }
        catch (e)
        {
            logError('RESTtransportPlugin::Initialize: Exception caught with message ' + e.message);
            return false;
        }
    };

    RESTtransportPlugin.prototype.Uninitialize = function () 
    {
        TransportPlugin_Template.prototype.Uninitialize.call(this);
        if (this._plugin) this._plugin.Disconnect();
        this._plugin = null;
    };

    RESTtransportPlugin.prototype._ConfigurePlugin = function(verb, username, password)
    {
        try 
        {
            if (verb) 
            {
                this._plugin.SetHttpMode(verb);
            }

            if (username || password)
            {
                if (username && password) 
                {
                    this._plugin.SetCredentials(username, password);
                }
                else // one is null, the other is not-null
                {
                    logError("RESTtransportPlugin: Username (" + username + ") and Password (" + password + ") are always required together");
                    return false;
                }
            }
            // else both not specified; this is okay

            var pluginVersion = this._plugin.GetVersion();
            if ((pluginVersion != "1") && (pluginVersion != "2"))
            {
                var system = getSystemPlugin();
                this._plugin.SetAgentName('McAfee ' + this.GetName() + ' transmitter_' + system.CreateGUID());
            }

            return true;
        }
        catch (e) 
        {
            logError("RESTtransportPlugin: Failed to configure transmission: exception is '" + e.message + "'");
            return false;
        }
    };

    RESTtransportPlugin.prototype._Send = function(payload)
    {

        // TODO: optimize the process so you don't have to connect every time
        if (!this._plugin)
        {
            logError('REST_Plugin::_Send Attempting to send without initializing');
            return null;
        }

        try
        {
            var requestHeader = this._CreateRequestHeaderString();
            if (requestHeader && !this._SetRequestHeaders(requestHeader))
            {
                //error reported already// Dont attempt to send
                return false;
            }

            //This will return a JSON string with the transmission result & response header and body
            return this._plugin.SendRequest(payload);
        }
        catch (e)
        {
            logError("REST_Plugin::_Send Failed to send data: exception is '" + e.message + "'");
        }

        return null;
    };

    RESTtransportPlugin.prototype._SetRequestHeaders = function(requestHeader)
    {
        try
        {
            if (this.GetVersion() == '1')
            {
                logError('RESTtransportPlugin._SetRequestHeaders: Attempted to set header for with an unsupported version (v=1)');
                return false;
            }

            if (!this._plugin)
            {
                logError('RESTtransportPlugin._SetRequestHeaders: Attempted to set header without initializing plugin');
                return false;
            }

            this._plugin.SetRequestHeaders(requestHeader);
            return true;
        }
        catch(e)
        {
            logError('RESTtransportPlugin::_SetRequestHeaders: Exception caught with message: ' + e.message);
            return false;
        }
    }

    RESTtransportPlugin.prototype._AddRequestHeader = function (headerName, headerValue)
    {
        try
        {
            this._requestHeaders[headerName] = headerValue;
        }
        catch (e)
        {
            logError('RESTtransportPlugin::_AddRequestHeaders: Exception caught with message: ' + e.message);
        }
    }

    RESTtransportPlugin.prototype._CreateRequestHeaderString = function ()
    {
        try
        {
            var requestHeaderString = '';
            for (var key in this._requestHeaders)
            {
                if (requestHeaderString)
                {
                    requestHeaderString += '\r\n';
                }

                requestHeaderString += key + ': ' + this._requestHeaders[key];
            }
            return requestHeaderString;
        }
        catch (e)
        {
            logError('RESTtransportPlugin::_CreateRequestHeaderString: Exception caught with message: ' + e.message);
            return null;
        }
    }

    RESTtransportPlugin.prototype._transportLog = function (uniqueid, eventDataString, transmissionStatus, transportNameOverride)
    {
        try
        {
            var transportName = this.GetName() + '_rest';
            if (null != transportNameOverride)
            {
                transportName = transportNameOverride;
            }

            logTransports(uniqueid, transportName, transmissionStatus, eventDataString);
        }
        catch (e)
        {
            logError('RESTtransportPlugin::_transportLog: Exception caught with message: ' + e.message);
        }
    };



ModuleManager.registerFactory("rest_transport", RESTtransportPlugin);
//export {RESTtransportPlugin};
//globalEngine.FactoryMap["rest_transport"] =  RESTtransportPlugin;
